import * as React from 'react';
import * as reactDom from 'react-dom';
import * as AbReader from '@vp/ab-reader';
import * as Auth from '@vp/auth';
import * as Swan from '@vp/swan';
import { v4 } from 'uuid';
import * as QueryString from 'query-string';
import Axios from 'axios';
export { Header } from './components/Header.js';
export { Footer } from './components/Footer.js';
export { BOOKENDS_META_TAG_NAME, BOOKENDS_SWAN_STYLES, BOOKEND_TYPES } from './constants.js';
export { BookendsMetaTag, getFooterComponentSlug, getHeaderComponentSlug } from './components/HeadTag.js';
export { getFooterKey, getHeaderKey } from './components/helpers.js';

// Peer Deps
if (typeof window !== "undefined") {
    window.bookends = {
        React: React,
        ReactDOM: reactDom,
        AbReader: AbReader,
        Auth: Auth,
        Axios: Axios,
        Swan: Swan,
        Uuid: { v4: v4 },
        QueryString: QueryString
    };
}
//# sourceMappingURL=index.js.map
